import { render, staticRenderFns } from "./personcard.vue?vue&type=template&id=2ca12d3f&scoped=true"
import script from "./personcard.vue?vue&type=script&lang=js"
export * from "./personcard.vue?vue&type=script&lang=js"
import style0 from "./personcard.vue?vue&type=style&index=0&id=2ca12d3f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca12d3f",
  null
  
)

export default component.exports